import TriggerComposerButtonContainer from './TriggerComposerButtonContainer';

export default TriggerComposerButtonContainer;
